<script>
  import {External, M} from "../external";

  export let config = null,
    onComplete,
    style = "",
    allowEmptyCaption = true,
    emailLinkPicker = false;

  const slots = $$props.$$slots;
  let link_display = "";

  let onClick = () => {
    External.Website.selectPage({
      allowEmptyCaption: allowEmptyCaption,
      hasNoFollow: true,
      isEmailLinkPicker: emailLinkPicker,
      selected: config || "",
      onSelect: function (result) {
        config = result;

        if (onComplete) {
          onComplete(result);
        }
      }
    });
  };

  export function select(item) {
    const copy = Object.assign({}, item, {});
    if (copy.link.startsWith("/") || copy.link !== "") {
      copy.external = false;
    }

    External.Website.selectPage({
      allowEmptyCaption: allowEmptyCaption,
      hasNoFollow: true,
      selected: copy,
      onSelect: function (result) {
        if (onComplete) {
          onComplete(result);
        }
      }
    });
  }

  $: {
    if (!slots) {
      if (!config || !config.link) {
        link_display = M.SELECT_LINK;
      } else {
        link_display = External.LinkPicker.getLinkDisplayText(config.link, null, config);
      }
    }
  }
</script>

{#if !slots}
  <input on:click={onClick} placeholder={link_display} class="template-select select-like" readonly="readonly" style={style} />
{:else}
  <slot />
{/if}
